exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".offers-grid{min-height:300px;margin:10px auto;-webkit-overflow-scrolling:touch;padding:16px}.offers-title{display:flex;align-items:center;width:50%}.offers-title__tooltip{width:max-content}.view-offers_btn{width:288px}@media (min-width:961px){.offers-grid{display:block;height:auto;max-width:1024px}.offers-title{transform:translateX(96px)}}@media (min-width:1201px){.offers-grid{max-width:1170px}.offers-title{transform:translateX(96px)}}@media (max-width:767px){.offers-title{width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./components/personalizedRecommendation/personalizedRecommendation-offers.scss
// module id = 870
// module chunks = 0